document.addEventListener('DOMContentLoaded',  function() {
  let container = document.getElementById('site-header-countdown'),
      dayBox =  document.querySelector('[js-site-header-countdown="day"]'),
      hourBox = document.querySelector('[js-site-header-countdown="hour"]'),
      minBox = document.querySelector('[js-site-header-countdown="min"]'),
      secBox = document.querySelector('[js-site-header-countdown="sec"]');
    
  if(container) {
    deadline = container.dataset.deadline;
  } else {
    return
  }

  if (!deadline || !dayBox || !hourBox  || !minBox || !secBox) {
    return;
  }

  function strToDate(dtStr) {
    if (!dtStr) return null
    let dateParts = dtStr.split("/");
    let timeParts = dateParts[2].split(" ")[1].split(":");
    dateParts[2] = dateParts[2].split(" ")[0];
    return dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0], timeParts[0], timeParts[1]);
  }

  let countDownDate = strToDate(deadline);

  function padStart(string, length, chars) {
    string = toString(string);
    length = toInteger(length);

    var strLength = length ? stringSize(string) : 0;
    return (length && strLength < length)
      ? (createPadding(length - strLength, chars) + string)
      : string;
  }
      
  let counter = setInterval(function() {
    let now = new Date(),
        nowUTC = new Date(
        now.getUTCFullYear(),
        now.getUTCMonth(),
        now.getUTCDate(),
        now.getUTCHours(),
        now.getUTCMinutes(),
        now.getUTCSeconds()
        ).getTime(),
        distance = countDownDate.getTime() - nowUTC,
        days = Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        seconds = Math.floor((distance % (1000 * 60)) / 1000);
  
    dayBox.innerHTML = String(days).padStart(2, '0');
    hourBox.innerHTML = String(hours).padStart(2, '0');
    minBox.innerHTML = String(minutes).padStart(2, '0');
    secBox.innerHTML = String(seconds).padStart(2, '0');

    if (distance < 0) {
      clearInterval(counter);
      container.classList.add('is-hidden')
    } else {
      container.classList.remove('is-hidden');
    }
  }, 1000);
  
})